<p-breadcrumb
  [model]="[{ label: 'Áreas de Exibição', routerLink: ['/display-areas'] }]"
  [home]="{ label: '', routerLink: ['/'], icon: 'ph-duotone ph-house text-lg' }"
/>

<p-toolbar class="mb-5 mt-5">
  <div class="w-full flex justify-between items-center">
    <div>
      <h5 class="font-bold">Áreas de Exibição</h5>
      <p>Gerencie as áreas de destaque da loja</p>
    </div>
  </div>
</p-toolbar>

<p-table
  #table
  [value]="displayAreas()"
  [lazy]="true"
  (onLazyLoad)="loadData($event)"
  [paginator]="true"
  [paginatorStyleClass]="'flex justify-end!'"
  [rows]="pageSize()"
  [rowsPerPageOptions]="[10, 20, 50]"
  [totalRecords]="totalRecords()"
  [loading]="loading()"
  [first]="paginationService.pageToFirst(pageNumber(), pageSize())"
  paginatorLocale="pt-BR"
>
  <ng-template #caption>
    <div class="flex gap-5 items-center">
      <p>Filtrar por:</p>

      <div class="w-100">
        <input
          pInputText
          type="text"
          [(ngModel)]="nameFilter"
          (ngModelChange)="onFilterChange()"
          placeholder="Nome"
          class="w-full"
        />
      </div>

      <div class="w-100">
        <input
          pInputText
          type="text"
          [(ngModel)]="slugFilter"
          (ngModelChange)="onFilterChange()"
          placeholder="Slug"
          class="w-full"
        />
      </div>
    </div>
  </ng-template>

  <ng-template #header>
    <tr>
      <th>Nome</th>
      <th>Slug</th>
      <th>Descrição</th>
      <th>Tipo</th>
      <th>Máx. Itens</th>
      <th>Status</th>
      <th>Ações</th>
    </tr>
  </ng-template>

  <ng-template #body let-item>
    <tr>
      <td>{{ item.name }}</td>
      <td>{{ item.slug }}</td>
      <td>{{ item.description || "-" }}</td>
      <td>{{ getItemTypeDescription(item.itemType) }}</td>
      <td>{{ item.maxItems }}</td>
      <td>
        <app-tag-status
          [status]="item.isActive ? 'Active' : 'Inactive'"
          [text]="item.isActive ? 'Ativo' : 'Inativo'"
        ></app-tag-status>
      </td>
      <td>
        <p-button
          icon="ph ph-pencil"
          class="mr-2"
          [rounded]="true"
          [outlined]="true"
          [routerLink]="'/display-areas/update/' + item.id"
        />
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="7">
        <p class="text-center">Nenhum registro encontrado!</p>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-toast />
<p-confirmdialog />
